/* eslint-disable indent */
import { Autocomplete, TextField, Box, Chip } from '@mui/material';
import { FilterOption } from './types';
import { autocompleteStyles, chipStyles, avatarStyles } from './styles';

interface FilterAutocompleteProps<T extends FilterOption> {
  value: T[] | undefined;
  options: T[] | undefined;
  onChange: (items: T[]) => void;
  getOptionLabel: (option: T) => string;
  placeholder: string;
  disabled?: boolean;
}

export const FilterAutocomplete = <T extends FilterOption>({
  value,
  options,
  onChange,
  getOptionLabel,
  placeholder,
  disabled = false,
}: FilterAutocompleteProps<T>) => (
  <Box>
    <Autocomplete
      style={{ padding: 0 }}
      multiple
      value={value ?? []}
      size="small"
      sx={autocompleteStyles}
      onChange={(_, items) => onChange(items)}
      options={options || []}
      getOptionLabel={getOptionLabel}
      disableCloseOnSelect
      disabled={disabled}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const displayName =
            'firstName' in option && option.firstName ? `${option.firstName} ${option.lastName}` : option.name;
          const { key, ...tagProps } = getTagProps({ index });

          return (
            <Chip
              key={key}
              label={displayName}
              sx={chipStyles}
              avatar={
                option.color ? (
                  <Box
                    sx={{
                      ...avatarStyles,
                      backgroundColor: option.color,
                    }}
                  />
                ) : undefined
              }
              {...tagProps}
            />
          );
        })
      }
      renderInput={(params) => <TextField {...params} placeholder={placeholder} variant="outlined" />}
    />
  </Box>
);
